// extracted by mini-css-extract-plugin
export default {"container":"TrailingBadge-module__container--wMID_","label":"TrailingBadge-module__label--cD4bB","title":"TrailingBadge-module__title--O0RpP"};